import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

document.body.style = 'background:  #56a0d3;'

ReactDOM.render(<App />, document.getElementById("root"));